import moment from 'moment';

import type { INullableMoment } from '@home/types/common';
import type { IGranularity, IDateValue } from '../types';

const COMMON_DATE_FORMATTER = 'YYYY-MM-DD';

export const getDateRangeOfTeaComponent = (
  granularity?: IGranularity,
  range?: IDateValue,
): [moment.Moment, moment.Moment] | undefined => {
  if (!granularity) return undefined;
  const [startDate, endDate] = range || [];
  const startDateM: INullableMoment = startDate ? moment(startDate) : null;
  const endDateM: INullableMoment = endDate ? moment(endDate) : null;
  if (!startDateM?.isValid() || !endDateM?.isValid()) return undefined;
  return [startDateM.startOf(granularity), endDateM.endOf(granularity)];
};

export const getDateValueOfTeaComponent = (
  loading?: boolean,
  granularity?: IGranularity,
  dateValue?: IDateValue,
): [moment.Moment, moment.Moment] | undefined => {
  if (loading) return undefined;
  if (!granularity) return undefined;
  const [startDate, endDate] = dateValue || [];
  const startDateM: INullableMoment = startDate ? moment(startDate) : null;
  const endDateM: INullableMoment = endDate ? moment(endDate) : null;
  if (!startDateM?.isValid() || !endDateM?.isValid()) return undefined;
  return [startDateM.startOf(granularity), endDateM.endOf(granularity)];
};

export const formatDateValueOfTeaComponent = (dates: moment.Moment[]): IDateValue => {
  const [startDateM, endDateM] = dates || [];
  if (!startDateM?.isValid() || !endDateM?.isValid()) return ['', ''];
  const startDate = startDateM.format(COMMON_DATE_FORMATTER);
  const endDate = endDateM.format(COMMON_DATE_FORMATTER);
  return [startDate, endDate];
};
